import { PublicRoutes } from "@/constants/routes";
import { t } from "@/context/language";
import { trackEvent } from "@/lib/dataLayer";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router";
import { PRESS_HIGHLIGHT_OUTLET } from "../constants/pressArticles";

// Pílula de anúncio que leva ao newsroom.
export function PressHighlightPill() {

  return (
    <Link
      to={PublicRoutes.NEWSROOM}
      onClick={() =>
        trackEvent({
          event: "press_highlight_click",
          outlet: PRESS_HIGHLIGHT_OUTLET,
        })
      }
      className="focus-visible:outline-primary group flex w-fit cursor-pointer items-center gap-3 rounded-full border border-gray-200 bg-gray-100 py-2.5 pr-3 pl-4 text-sm font-medium text-black transition hover:border-gray-300 hover:bg-gray-200 hover:shadow-sm focus-visible:outline-2 focus-visible:outline-offset-2 sm:text-base"
    >
      <span className="relative flex size-2.5 shrink-0" aria-hidden="true">
        <span className="bg-primary absolute inline-flex size-full animate-ping rounded-full opacity-75 motion-reduce:hidden" />
        <span className="bg-primary relative inline-flex size-full rounded-full" />
      </span>

      <span className="text-left">{t.press.highlight}</span>

      <ChevronRight
        className="size-4 shrink-0 text-gray-400 transition group-hover:translate-x-0.5 group-hover:text-gray-600"
        aria-hidden="true"
      />
    </Link>
  );
}
